import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const getEmptyTeamMember = () => {
  return {
    name: "",
    designation: "",
    batch: "",
    email: "",
    instagram: "",
    github: "",
    twitter: "",
    facebook: "",
    linkedin: "",
  };
};

function EditPersonForm() {
  const [teamMember, setTeamMember] = useState(getEmptyTeamMember());
  const profile = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const id = window.location.pathname.split("/").pop();
    axios
      .get(`${BASE_URL}/persons/single/${id}`)
      .then((res) => {
        const tm = res.data.person;
        // Handle not to store key imgUrl in state
        // delete event.imgUrl;
        setTeamMember({
          ...tm,
        });
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  const handleChange = (e) => {
    setTeamMember({
      ...teamMember,
      [e.target.name]: e.target.value,
    });
  };

  const handleTeamMemberUpdate = async (e) => {
    e.preventDefault();
    let message = "";
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("UnAuthorized");
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const formData = new FormData();
      if (profile.current.files[0]) {
        formData.append("profile", profile.current.files[0]);
        const response = await axios.put(
          `${BASE_URL}/persons/single/profile/${teamMember._id}`,
          formData,
          config
        );
        if (response.data.success === true) {
          message = response.data.message;
          // alert(message);
        } else {
          throw new Error(response.data.message);
        }
      }
      const newFormData = new FormData();
      for (const key in teamMember) {
        newFormData.append(key, teamMember[key]);
      }
      newFormData.delete("imgUrl");
      const response = await axios.put(
        `${BASE_URL}/persons/single/${teamMember._id}`,
        newFormData,
        config
      );
      if (response.data.success === true) {
        message += response.data.message;
        alert(message);
        navigate("/admin/team");
      } else {
        throw new Error(response.data.message);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleGoBack = () => {
    navigate("/admin/team");
  };

  return (
    <div className="py-3 container is-fluid">
      <form encType="multipart/form-data">
        <div className="columns is-centered">
          <div className="column is-two-thirds">
            <div className="field">
              <label className="label">Person Name</label>
              <div className="control">
                <input
                  autoFocus
                  name="name"
                  className="input"
                  value={teamMember.name}
                  type="text"
                  placeholder="Person Name"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Person Designation</label>
              <div className="control">
                <input
                  name="designation"
                  className="input"
                  type="text"
                  value={teamMember.designation}
                  placeholder="Person Position"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Batch</label>
              <div className="control">
                <input
                  name="batch"
                  className="input"
                  type="text"
                  value={teamMember.batch}
                  placeholder="Ex. 2022-2023"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="field">
              <label className="label">Current Person Profile</label>
              <div className="control">
                <figure className="image is-square">
                  <img
                    src={teamMember.imgUrl}
                    alt="Team member"
                    style={{
                      width: "100%",
                      objectFit: "scale-down",
                    }}
                  />
                </figure>
              </div>
            </div>

            <div className="field">
              <label className="label">Person Profile</label>
              <div className="control">
                <input
                  name="profile"
                  className="input"
                  type="file"
                  ref={profile}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Person Email</label>
              <div className="control">
                <input
                  name="email"
                  className="input"
                  type="email"
                  value={teamMember.email}
                  placeholder="student@example.com"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Instagram</label>
              <div className="control has-icons-left">
                <input
                  name="instagram"
                  className="input"
                  type="text"
                  value={teamMember.instagram}
                  placeholder="Instagram Username"
                  onChange={handleChange}
                />
                <span className="icon is-small is-left">
                  <i className="fa-brands fa-instagram"></i>
                </span>
              </div>
            </div>

            <div className="field">
              <label className="label">Github</label>
              <div className="control has-icons-left">
                <input
                  name="github"
                  className="input"
                  type="text"
                  value={teamMember.github}
                  placeholder="Github Username"
                  onChange={handleChange}
                />
                <span className="icon is-small is-left">
                  <i className="fa-brands fa-github"></i>
                </span>
              </div>
            </div>

            <div className="field">
              <label className="label">Twitter</label>
              <div className="control has-icons-left">
                <input
                  name="twitter"
                  className="input"
                  type="text"
                  value={teamMember.twitter}
                  placeholder="Twitter Username"
                  onChange={handleChange}
                />
                <span className="icon is-small is-left">
                  <i className="fa-brands fa-twitter"></i>
                </span>
              </div>
            </div>

            <div className="field">
              <label className="label">FaceBook</label>
              <div className="control has-icons-left">
                <input
                  name="facebook"
                  className="input"
                  type="text"
                  value={teamMember.facebook}
                  placeholder="Facebook Username"
                  onChange={handleChange}
                />
                <span className="icon is-small is-left">
                  <i className="fa-brands fa-facebook"></i>
                </span>
              </div>
            </div>

            <div className="field">
              <label className="label">Linkedin</label>
              <div className="control has-icons-left">
                <input
                  name="linkedin"
                  className="input"
                  type="text"
                  value={teamMember.linkedin}
                  placeholder="Linkedin Username"
                  onChange={handleChange}
                />
                <span className="icon is-small is-left">
                  <i className="fa-brands fa-linkedin"></i>
                </span>
              </div>
            </div>

            <div className="field is-grouped">
              <div className="control">
                <button
                  className="button is-link is-success"
                  onClick={handleTeamMemberUpdate}
                >
                  Save Changes
                </button>
              </div>
              <div className="control">
                <button
                  className="button is-link is-light is-info"
                  onClick={handleGoBack}
                >
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditPersonForm;
